import interceptors from '@/api/supplier/interceptorsSupplier';
import { clientSupplier } from '@/api/supplier/client';
import qs from "qs";

clientSupplier.interceptors.request.use(interceptors.auth, interceptors.onError);

function getReturDelivery(params) {
	return clientSupplier.get("api-supplier/pdor/data", {
		params: params,
	});
}

function getStatusRD() {
	return clientSupplier.get("api-supplier/options/retur-delivery-status");
}

function getReturforDelivery() {
	return clientSupplier.get("api-supplier/options/retur-for-delivery");
}

function exportReturDelivery(params) {
	return clientSupplier.get("api-supplier/pdor/export", {
		params: params,
	});
}

function detailReturDelivery(params) {
	return clientSupplier.get("api-supplier/pdor/detail", {
		params: {
			pdor_code : params
		},
	});
}

function createReturDelivery (params) {
	return clientSupplier.post("api-supplier/pdor/create", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getReturDelivery,
	getStatusRD,
	getReturforDelivery,
	exportReturDelivery,
	detailReturDelivery,
	createReturDelivery,
};